import { createFileRoute } from '@tanstack/react-router'
import EditionSearchTabs from 'Edition/components/search/EditionSearchTabs'
import { claimTypesEnum } from 'User/utils/claims'

import { Guard } from './-guard'

export const Route = createFileRoute('/_editionsearch')({
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_work]}>
            <EditionSearchTabs />
        </Guard>
    ),
})
